export enum VariationKey {
  ORIGINAL = 'original-page',
  VARIATION_1 = 'variation-1',
}

export enum VariationName {
  ORIGINAL = 'original-page',
  DEFAULT_CORE_PLAN = 'default-core-plan',
  PLAN_VIEW_1 = 'plan-view-1',
  PLAN_VIEW_2 = 'plan-view-2',
  CORE_PLAN_ZERO_TAG = 'core-plan-zero-tag',
}

export const VARIATION_NAME_TO_KEY_MAP = {
  [VariationName.DEFAULT_CORE_PLAN]: VariationKey.VARIATION_1,
  [VariationName.PLAN_VIEW_1]: VariationKey.VARIATION_1,
  [VariationName.PLAN_VIEW_2]: VariationKey.VARIATION_1,
  [VariationName.CORE_PLAN_ZERO_TAG]: VariationKey.VARIATION_1,
  [VariationName.ORIGINAL]: VariationKey.ORIGINAL,
} as const satisfies Record<VariationName, VariationKey>;

export enum ExperienceMap {
  TEST = '1004184758',
  CORE_PLAN_AS_DEFAULT = '1004185286',
  CORE_PLAN_ZERO_TAG = '1004196402',
}

export type RawConvertVariationKey = `${string}-${VariationKey}`;
interface RawConvertVariation {
  id?: string;
  key?: RawConvertVariationKey;
  name?: string;
}

interface RawConvertExperienceData {
  variation?: RawConvertVariation;
}

export interface RawConvertData {
  experiences?: Partial<Record<ExperienceMap, RawConvertExperienceData>>;
}

export interface ExperienceResult {
  id: ExperienceMap;
  variationKey: VariationKey;
}

declare global {
  interface Window {
    convert?: {
      currentData?: RawConvertData;
      data?: RawConvertData;
    };
  }
}
